function getCrypto() {
  return globalThis.crypto;
}

function randomHex(bytes: number) {
  const cryptoApi = getCrypto();
  if (cryptoApi?.getRandomValues) {
    const values = new Uint8Array(bytes);
    cryptoApi.getRandomValues(values);
    return Array.from(values, (value) => value.toString(16).padStart(2, "0")).join("");
  }

  let output = "";
  for (let index = 0; index < bytes; index += 1) {
    output += Math.floor(Math.random() * 256).toString(16).padStart(2, "0");
  }
  return output;
}

export function createId() {
  const cryptoApi = getCrypto();
  if (typeof cryptoApi?.randomUUID === "function") {
    return cryptoApi.randomUUID();
  }

  const hex = randomHex(16);
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-4${hex.slice(13, 16)}-${((parseInt(hex.slice(16, 18), 16) & 0x3f) | 0x80).toString(16)}${hex.slice(18, 20)}-${hex.slice(20, 32)}`;
}

function fallbackDigest(value: string) {
  let hash = 0x811c9dc5;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return `fnv1a-${(hash >>> 0).toString(16).padStart(8, "0")}`;
}

export async function sha256Digest(value: string) {
  const cryptoApi = getCrypto();
  if (!cryptoApi?.subtle) return fallbackDigest(value);

  try {
    const bytes = new TextEncoder().encode(value);
    const digest = await cryptoApi.subtle.digest("SHA-256", bytes);
    return Array.from(new Uint8Array(digest), (item) => item.toString(16).padStart(2, "0")).join("");
  } catch {
    return fallbackDigest(value);
  }
}
